import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/logo.png"
      width="150px"
      {...props}
    />
  );
}

export default Logo;
